import { render } from "./ItemsDT.vue?vue&type=template&id=637a2f73"
import script from "./ItemsDT.vue?vue&type=script&lang=js"
export * from "./ItemsDT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__